// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IOfferUnderground } from './OfferUnderground';
import type { IDiscount } from '../discount/Discount';

export interface IRecItemV2 {
  /** Ссылка на объявление **/
  url: string;
  /** Ссылка на картинку **/
  imageUrl?: string;
  /** Id объявления **/
  offerId?: number;
  /** Заголовок (напр. 6 800 000 ₽) **/
  title?: string;
  /** Подзаголовок **/
  subtitle?: string;
  /** Дополнительная информация **/
  info?: string;
  /** Аналитическая информация по объекту **/
  analyticsData?: object;
  underground?: IOfferUnderground;
  /** Находится ли данное объявление в избранном у пользователя **/
  isFavorite?: boolean;
  /** Тип сделки **/
  dealType?: EDealType;
  /** Тип предложения **/
  entityType?: EEntityType;
  /** Это 'новое' объявление **/
  isNewLabel?: boolean;
  /** Скидка на объявление **/
  discount?: IDiscount;
  /** JWE токен контекста для CPC **/
  contextToken?: string;
  /** Флаг CPC аукциона **/
  isCpcAuction?: boolean;
}

export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EEntityType {
  /** Жилая **/
  'OfferResidental' = 'offerResidental',
  /** Загородка **/
  'OfferSuburban' = 'offerSuburban',
  /** Коммерческая **/
  'OfferCommercial' = 'offerCommercial',
}
